import { Box } from '@mui/material'
import { ReactNode } from 'react'

interface TabPanelProps {
  children?: ReactNode
  node?: ReactNode
  index: number
  value: number
}

const CustomTabPanel = ({ children, value, index, node, ...other }: TabPanelProps) => {
  return (
    <Box
      sx={{ width: '100%', height: '100%' }}
      role='tabpanel'
      hidden={value !== index}
      id={`simple-tabpanel-${index}`}
      aria-labelledby={`simple-tab-${index}`}
      {...other}
    >
      {value === index && <Box>{children}</Box>}
      {value === index && <Box>{node}</Box>}
    </Box>
  )
}

export default CustomTabPanel
